export default __webpack_public_path__ + "media/images/app-icon-2a678d5485646a40aed1b4a42b064707.svg";